module.exports = __webpack_public_path__ + "img/SORIANA_MOBILE.400cfece.png";